<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">{{ $t("drivers.new_driver", { label: driverLabel }) }}</div>
            <div class="dialog-content">
                <v-form ref="form_new_driver">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="login"
                                :label="$t('drivers.login')"
                                dense
                                hide-details="auto"
                                light
                                outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="lastname"
                                :label="$t('drivers.name')"
                                dense
                                hide-details="auto"
                                light
                                outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="firstname"
                                :label="$t('drivers.firstname')"
                                dense
                                hide-details="auto"
                                light
                                outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
            <div class="dialog-footer d-flex">
                <v-btn elevation="0" @click="showDialog = false">
                    {{ $t("global.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" color="primary" elevation="0"
                       @click="createDriver">
                    {{ $t("global.validate") }}
                </v-btn
                >
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
import Config from "../../../config.singleton";

export default {
    name: "NewDriver",
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            login: "",
            lastname: "",
            firstname: "",
            loading: false
        };
    },
    computed: {
        driverLabel() {
            return Config.driver_label ?? $tc("drivers.drivers", 2)
        },
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        async createDriver() {
            try {
                this.loading = true
                const driver = (await this.$api.drivers.create({
                    login: this.login,
                    firstname: this.firstname,
                    lastname: this.lastname
                })).data
                this.loading = false
                this.$emit('newDriver', driver)
            } catch (e) {
                this.loading = false
            }
        }
    }
};
</script>
